import { connect } from 'react-redux';
import PresentationComponent from '../../components/event/EventQueryExposureModal';
import { exposeEventQuery } from '../../actions/events/events';
import {
  getEventAggregationColumn,
  getEventAggregationType,
  getEventExposureError,
  getEventName,
  getEventsGroupColumn,
  getEventSql,
} from '../../reducers/analyticsApp';
import { isValidEvent } from '../../utils/event/common';

const mapStateToProps = (state, { id }) => ({
  sql: getEventSql(state, id),
  error: getEventExposureError(state, id),
  showButton:
    !!getEventsGroupColumn(state, id) &&
    isValidEvent({
      aggregationType: getEventAggregationType(state, id),
      aggregationColumn: getEventAggregationColumn(state, id),
      name: getEventName(state, id),
    }),
});

const mapDispatchToProps = (dispatch, { id, clauseId }) => ({
  expose: () => dispatch(exposeEventQuery(id, clauseId)),
});

const EventsQueryExposureModal = connect(
  mapStateToProps,
  mapDispatchToProps
)(PresentationComponent);

export default EventsQueryExposureModal;
